import { z } from "zod";
import { ImageGenerationModel } from "@/gql/graphql";

export const imageGenerationValidation = z.object({
  prompt: z.string().optional(),
  model: z
    .nativeEnum(ImageGenerationModel)
    .default(ImageGenerationModel.Openai),
});

export type ImageGenerationFormData = z.infer<typeof imageGenerationValidation>;
